import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header-nav" }
const _hoisted_2 = ["href", "onClick"]
const _hoisted_3 = {
  key: 1,
  class: "header-nav__link header-nav__link--stub"
}

import { i18n } from "@/i18n";
import { computed } from "vue"
import { useRoute } from "vue-router"
import type { RouteLocationRaw } from "vue-router"
import { workerStore } from "@/store/worker"
import { chatsStore } from "@/store/chats"
import { rootStore } from "@/store/index"
import type { Worker } from "@/ api/WorkerApi"

type AccessKey = "CalendarAccess" | "AnalyticsAccess" | "StorageAccess"

type NavLink = {
	label: string
	route?: string
	accessKey?: AccessKey
	isStub: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderNavLinks',
  setup(__props) {

const route = useRoute()
const wStore = workerStore()
const root = rootStore()

const links = computed<NavLink[]>(() => [
	{ label: String(i18n.global.t('page_title_main')), route: "/main", isStub: false },
	{ label: String(i18n.global.t('page_title_calendar')), route: "/calendar", accessKey: "CalendarAccess", isStub: false },
	{ label: String(i18n.global.t('page_title_analytics')), route: "/analytics", accessKey: "AnalyticsAccess", isStub: false },
	{ label: String(i18n.global.t('page_title_settings')), route: "/settings", isStub: false },
	{ label: String(i18n.global.t('page_title_storage')), route: "/storage", accessKey: "StorageAccess", isStub: false }
])

const isAllowed = (link: NavLink, profile: Worker | null) => {
	if (!link.accessKey) {
		return true
	}
	if (!profile) {
		return false
	}
	const value = profile[link.accessKey]
	if (link.accessKey === "StorageAccess") {
		return Number(value) > 0
	}
	return Boolean(value)
}

const visibleLinks = computed(() =>
	links.value.filter(link => isAllowed(link, wStore.workerProfile))
)

const isHomeLink = (link: NavLink) => link.route === '/main'
// «Аналитика» и «Склад» открывают одну страницу Аналитики с разными сегментами.
// /storage роутер перенаправляет на сегмент «Позиции склада».
const isAnalyticsLink = (link: NavLink) => link.route === '/analytics'
const isStorageLink = (link: NavLink) => link.route === '/storage'

const linkTarget = (link: NavLink): RouteLocationRaw => {
	if (isHomeLink(link)) {
		return {
			path: '/main',
			query: {
				page: 'chat',
				mode: 'list'
			}
		}
	}
	if (isAnalyticsLink(link)) {
		return {
			path: '/analytics',
			query: { segment: String(root.lastAnalyticsMode) }
		}
	}
	return link.route as string
}

const isActive = (link: NavLink) => {
	if (isHomeLink(link)) {
		return route.path === '/main' && route.query.page === 'chat'
	}
	if (isAnalyticsLink(link)) {
		return route.path === '/analytics' && !root.isStorageMode
	}
	if (isStorageLink(link)) {
		return route.path === '/analytics' && root.isStorageMode
	}
	return link.route === route.path
}

const onClick = (
	link: NavLink,
	navigate: (e: MouseEvent) => void,
	e: MouseEvent
) => {
	// Модифицирующий/средний клик — отдаём браузеру, чтобы открылась новая вкладка
	if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
		return
	}

	if (isHomeLink(link)) {
		chatsStore().setMode('list')
		chatsStore().setOpenedChat(null)
	}

	navigate(e)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleLinks.value, (link) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: link.label
      }, [
        (!link.isStub && link.route)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: linkTarget(link),
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _createElementVNode("a", {
                  href: href,
                  class: _normalizeClass(["header-nav__link", { 'header-nav__link--active': isActive(link) }]),
                  onClick: ($event: any) => (onClick(link, navigate, $event))
                }, _toDisplayString(link.label), 11, _hoisted_2)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(link.label), 1))
      ], 64))
    }), 128))
  ]))
}
}

})